export function OutlineFolderIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9984 7.0016V6.92C9.9984 5.8592 9.1392 5 8.0784 5H4.92C3.8592 5 3 5.8592 3 6.92V17.0816C3 18.1424 3.8592 19.0016 4.92 19.0016H19.08C20.1408 19.0016 21 18.1424 21 17.0816V8.9216C21 7.8608 20.1408 7.0016 19.08 7.0016H9.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
